<template>
	<el-drawer :modal="false" :visible.sync="is_visible"
		:title="'Detail Loan Ec'" class="drawer-detail-loan-ec" size="60%"
		@close="hide()">
		<b-container>
			<LoanEligibilityCalculator ref="loan_eligibility" :is-view-only="true" :refresh="is_visible"/>
		</b-container>
	</el-drawer>
</template>
<script>
import { Drawer } from 'element-ui'
import LoanEligibilityCalculator from '@/views/CustomerProfile/CenterComponents/LoanEligible/LoanEligibilityCalculator'

import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';

export default {
	components: {
		LoanEligibilityCalculator,
		[Drawer.name]: Drawer
	},
	data() {
		return {
			is_visible: false,
			is_loading: false
		}
	},
	methods: {
		...mapActions(useCustomerStore, [
			'clearLoanEcState',
			'getCustomer',
      'getLoanEC',
			'setFormLoanEc'
    ]),
		show(cust_id, loan_ec_id){
			if(!_gHlp.isEmpty(cust_id) && !_gHlp.isEmpty(loan_ec_id)){
				_gHlp.setLoading('fetch_loan_ec')
				this.getLoanEC(loan_ec_id,cust_id).then(resp => {
					this.is_visible = true
					_gHlp.removeLoading('fetch_loan_ec')
					_gHlp.setLoading('init_tab_loan_eligible')
				}).catch(err=>{
					_gHlp.removeLoading('fetch_loan_ec')
				})
			}
		},
		hide() {
			this.clearLoanEcState()
			this.is_visible = false
		}
	}
}
</script>